import { render } from "./CreateGroup.vue?vue&type=template&id=6286b424&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroup.vue?vue&type=script&lang=js"

import "./CreateGroup.vue?vue&type=style&index=0&id=6286b424&lang=scss&scoped=true"
import "./CreateGroup.vue?vue&type=style&index=1&id=6286b424&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6286b424"]])

export default __exports__